export default "__VITE_ASSET__BEQIYSJp__"